import React, { useEffect } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import SectionLayout from 'components/layouts/SectionLayout';
import EbookForm from 'components/forms/EbookForm';

function InsidersGuide() {
  useEffect(() => {
    document.title = "The Insider's Guide to Alternative Health Insurance - Insurance Enterprise";
  }, []);

  const PageContent = () => (
    <div className="max-w-6xl mx-auto py-4">
      {/* Premium FREE EBOOK Header */}
      <div className="flex flex-col items-center justify-center text-center mb-8">
        <div className="inline-flex items-center space-x-2 px-4 py-1.5 rounded-full bg-secondary/10 border border-secondary/25 shadow-xs mb-2">
          <span className="w-2.5 h-2.5 rounded-full bg-secondary animate-pulse"></span>
          <span className="text-xs font-extrabold tracking-widest uppercase text-secondary">
            EXCLUSIVE 2026 RESOURCE
          </span>
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-slate-900 uppercase">
          FREE <span className="text-secondary">EBOOK</span>
        </h1>
        <div className="w-16 h-1 bg-secondary/40 rounded-full mt-2"></div>
      </div>

      <div className="flex flex-col lg:flex-row gap-8 items-start justify-center">
        {/* Left Column (Desktop) / Second (Mobile): Brief Guide Summary */}
        <div className="w-full lg:w-1/2 space-y-6 order-2 lg:order-1">
          <h2 className="text-3xl font-bold text-base-content leading-tight">
            The Insider's Guide to Alternative Health Insurance
          </h2>
          <p className="text-sm text-base-content/80 leading-relaxed">
            Healthcare costs continue to rise in 2026. Our comprehensive educational guide provides actionable strategies to protect your family and budget without sacrificing quality care.
          </p>

          <div className="space-y-4 pt-2">
            <div className="flex items-start space-x-3">
              <span className="text-secondary font-bold text-lg">•</span>
              <div>
                <h4 className="font-semibold text-sm text-base-content">High-Deductible ACA Alternatives</h4>
                <p className="text-xs text-base-content/70">Understand fixed-indemnity benefit plans designed to eliminate heavy out-of-pocket costs.</p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <span className="text-secondary font-bold text-lg">•</span>
              <div>
                <h4 className="font-semibold text-sm text-base-content">Cash-Payout Indemnity Features</h4>
                <p className="text-xs text-base-content/70">Discover plans that pay direct cash benefits straight to policyholders upon diagnosis or care.</p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <span className="text-secondary font-bold text-lg">•</span>
              <div>
                <h4 className="font-semibold text-sm text-base-content">PPO Network Discounts</h4>
                <p className="text-xs text-base-content/70">Tap into nationwide doctor and hospital networks with deep pre-negotiated re-pricing savings.</p>
              </div>
            </div>
          </div>

          <div className="pt-4 border-t border-base-200 space-y-3">
            <h3 className="text-xl font-bold text-base-content flex items-center flex-wrap gap-2">
              <span>Why Take a Look at This Guide?</span>
              <span className="text-xs font-black uppercase tracking-wider bg-secondary/15 text-secondary border border-secondary/30 px-2.5 py-0.5 rounded-md inline-block">
                Ebook
              </span>
            </h3>
            <p className="text-sm text-base-content/80 leading-relaxed">
              Healthcare costs are shifting fast. Whether you want to lower your monthly premiums, protect yourself against high out-of-pocket deductibles, or simply explore smarter coverage options, this free guide breaks down your choices in plain, straightforward language—giving you full control over your health and budget.
            </p>
          </div>
        </div>

        {/* Right Column (Desktop) / First (Mobile): Clean Agent-Style Form */}
        <div className="w-full lg:w-1/2 order-1 lg:order-2">
          <EbookForm />
        </div>
      </div>
    </div>
  );

  return (
    <PageLayout content={<SectionLayout content={<PageContent />} />} />
  );
}

export default InsidersGuide;
